
@if ((userService.isLoggedin$|async)!=true && (userService.isLoggedin$|async)!=false) {
  <div id="cover-spin"></div>
}
<ng-progress role="progressbar" aria-label="progress bar"></ng-progress>
@if (userService.loginVerified) {
  <div class="app-wrapper">
    <router-outlet></router-outlet>
  </div>
}